import { useEmployeesByName } from '@hakimo-ui/hakimo/data-access';
import { EmployeeFilterValue } from '@hakimo-ui/hakimo/types';
import { currentTenantAtom } from '@hakimo-ui/hakimo/util';
import { useAtomValue } from 'jotai';
import { MultiSelectFilter } from '../multi-select-filter/MultiSelectFilter';

interface Props {
  enableNegativeFilters?: boolean;
  employees: EmployeeFilterValue;
  onChange: (value: EmployeeFilterValue) => void;
  label: string;
}

export function EmployeeFilter(props: Props) {
  const { enableNegativeFilters = false, employees, onChange, label } = props;
  const getEmployeesByName = useEmployeesByName();
  const currentTenant = useAtomValue(currentTenantAtom);

  return (
    <MultiSelectFilter
      value={employees}
      label={label}
      enableNegativeFilters={enableNegativeFilters}
      onChange={onChange}
      getOptions={(name: string) =>
        getEmployeesByName(name, currentTenant?.id ?? '')
      }
    />
  );
}

export default EmployeeFilter;
